export type PublicLandingSection = 'features' | 'pricing' | 'faq';

const PUBLIC_LOCALE_SEGMENTS = new Set([
  'en', 'id', 'es', 'pt', 'pt-br', 'ru', 'ru-ru', 'tr', 'tr-tr',
  'vi', 'vi-vn', 'th', 'th-th', 'ar', 'ar-sa', 'zh', 'zh-cn', 'ja', 'ko',
]);

export function publicHomePath(pathname: string): string {
  const firstSegment = pathname.split('/').filter(Boolean)[0];
  return firstSegment && PUBLIC_LOCALE_SEGMENTS.has(firstSegment.toLowerCase())
    ? `/${firstSegment}/`
    : '/';
}

export function publicSectionPath(pathname: string, section: PublicLandingSection): string {
  return `${publicHomePath(pathname)}#${section}`;
}
